import React from 'react';
import { Helmet } from 'react-helmet-async';
import PageHeader from '../components/PageHeader';

function BusinessVerification() {
	return (
		<>
			<Helmet>
				<title>Business Verification | A-Z Home Improvement LLC</title>
				<meta name="description" content="Verify A-Z Home Improvement LLC business credentials — AZ ROC license, insurance, business registration, and SMS program information." />
			</Helmet>
			<PageHeader
				title="Business Verification"
				subtitle="Verifiable credentials for A-Z Home Improvement LLC."
			/>

			<section className="section">
				<div className="container" style={{ maxWidth: 820 }}>

					<p className="helper" style={{ maxWidth: 620, marginBottom: 28 }}>
						This page provides third-party-verifiable information about A-Z Home Improvement LLC for carrier verification, business vetting, or customer due diligence purposes.
					</p>

					{/* Business info */}
					<div className="card" style={{ padding: 28, marginBottom: 24 }}>
						<h2 style={{ marginTop: 0 }}>Business Information</h2>
						<table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 14 }}>
							<tbody>
								{[
									['Legal Name', 'A-Z Home Improvement LLC'],
									['DBA / Trade Name', 'A-Z Home Improvement'],
									['Entity Type', 'Limited Liability Company (LLC)'],
									['State of Formation', 'Arizona'],
									['Physical Address', '3842 W. McDowell Rd, Suite 110, Phoenix, AZ 85009'],
									['Phone', '(602) 390-2536'],
									['Email', 'info@azhomefundingservices.com'],
									['Website', 'azhomefundingservices.com'],
									['Industry', 'Residential and Commercial Home Remodeling &amp; Renovation'],
									['In Operation Since', '2019'],
								].map(([k, v]) => (
									<tr key={k} style={{ borderBottom: '1px solid #eee' }}>
										<td style={{ padding: '9px 12px', fontWeight: 600, width: '40%', color: '#555' }} dangerouslySetInnerHTML={{ __html: k }} />
										<td style={{ padding: '9px 12px' }} dangerouslySetInnerHTML={{ __html: v }} />
									</tr>
								))}
							</tbody>
						</table>
					</div>

					{/* Licensing */}
					<div className="card" style={{ padding: 28, marginBottom: 24 }}>
						<h2 style={{ marginTop: 0 }}>Contractor License Verification</h2>
						<table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 14 }}>
							<tbody>
								{[
									['License Number', 'AZ ROC #XXXXX8142'],
									['License Type', 'General Contractor — Residential &amp; Commercial'],
									['Status', 'Active'],
									['Issuing State Agency', 'Arizona Registrar of Contractors (ROC)'],
									['Verify at', 'roc.az.gov (public license lookup)'],
								].map(([k, v]) => (
									<tr key={k} style={{ borderBottom: '1px solid #eee' }}>
										<td style={{ padding: '9px 12px', fontWeight: 600, width: '40%', color: '#555' }} dangerouslySetInnerHTML={{ __html: k }} />
										<td style={{ padding: '9px 12px' }} dangerouslySetInnerHTML={{ __html: v }} />
									</tr>
								))}
							</tbody>
						</table>
					</div>

					{/* SMS Program */}
					<div className="card" style={{ padding: 28, marginBottom: 24 }}>
						<h2 style={{ marginTop: 0 }}>SMS Program Description (A2P / 10DLC)</h2>
						<table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 14 }}>
							<tbody>
								{[
									['Sending Entity', 'A-Z Home Improvement LLC'],
									['Use Case', 'Mixed (Marketing): Remodeling estimates, appointment reminders, project updates, promotional offers'],
									['Opt-In Location', 'azhomefundingservices.com/contact — explicit checkbox with full consent language'],
									['Opt-Out', 'Reply STOP · azhomefundingservices.com/opt-out'],
									['Help', 'Reply HELP · (602) 390-2536 · support@azhomefundingservices.com'],
									['Third-Party Data Sharing', 'None — no mobile data shared with third parties for marketing'],
									['Call to Action URL', 'azhomefundingservices.com/contact'],
									['Message Flow', 'Customer submits web form with explicit SMS consent → receives appointment or estimate confirmation SMS → project-phase updates or promotions during engagement'],
								].map(([k, v]) => (
									<tr key={k} style={{ borderBottom: '1px solid #eee' }}>
										<td style={{ padding: '9px 12px', fontWeight: 600, width: '40%', color: '#555' }}>{k}</td>
										<td style={{ padding: '9px 12px' }}>{v}</td>
									</tr>
								))}
							</tbody>
						</table>
					</div>

					{/* Sample messages */}
					<div className="card" style={{ padding: 28, marginBottom: 24 }}>
						<h2 style={{ marginTop: 0 }}>Sample SMS Messages</h2>
						{[
							{
								label: 'Estimate Confirmation',
								msg: 'Hi [Name], your free estimate with A-Z Home Improvement is confirmed for [Date] at [Time]. Questions? Call (602) 390-2536. Reply STOP to opt out.',
							},
							{
								label: 'Appointment Reminder',
								msg: 'Reminder: Your A-Z Home Improvement estimate appointment is tomorrow, [Date] at [Time]. Reply STOP to opt out or HELP for help.',
							},
							{
								label: 'Project Kick-Off',
								msg: 'Hi [Name], your [Kitchen Remodel] project is scheduled to start [Date]. Our crew will arrive between 7–8am. Questions? Call (602) 390-2536. Reply STOP to opt out.',
							},
							{
								label: 'Promotional Offer',
								msg: 'A-Z Home Improvement: This month only — 10% off bathroom renovations scheduled before [Date]. Call (602) 390-2536 or visit azhomefundingservices.com/contact. Reply STOP to opt out.',
							},
						].map(s => (
							<div key={s.label} style={{ background: '#f5f5f5', borderRadius: 8, padding: 14, marginBottom: 12 }}>
								<p className="helper" style={{ margin: '0 0 6px', fontSize: 12, fontWeight: 700, textTransform: 'uppercase', letterSpacing: 1 }}>{s.label}</p>
								<p style={{ margin: 0, fontSize: 13, fontFamily: 'monospace' }}>{s.msg}</p>
							</div>
						))}
					</div>

					{/* Authorized contact */}
					<div className="card" style={{ padding: 28 }}>
						<h2 style={{ marginTop: 0 }}>Authorized Business Contact</h2>
						<address style={{ fontStyle: 'normal' }}>
							<strong>Robert Aguilar — Owner &amp; General Contractor</strong><br />
							A-Z Home Improvement LLC<br />
							3842 W. McDowell Rd, Suite 110<br />
							Phoenix, AZ 85009<br />
							Phone: <a href="tel:+16023902536" style={{ color: 'var(--brand)' }}>(602) 390-2536</a><br />
							Email: <a href="mailto:info@azhomefundingservices.com" style={{ color: 'var(--brand)' }}>info@azhomefundingservices.com</a>
						</address>
					</div>

				</div>
			</section>
		</>
	);
}

export default BusinessVerification;
